import React, { FC, useCallback, useEffect, useState } from "react";
import { icons } from "../../icons";
import {
  IconBackground,
  Title,
  TitleWrapper,
  Content,
  CloseButton,
  ProgressBar,
  AlertCustom,
  ThinText,
} from './styles'
import Warning from './warning.svg'
import Error from './error.svg'
import Info from './info.svg'
import ImageIcon from '../side-bar/icons/images-hover.svg'
import { useTranslation } from "react-i18next";
import SVG from "react-inlinesvg";
import { ThemeProvider } from "styled-components";
import theme from '../../themes'

const Alert:FC<any> = (props) => {

  const {
    severity,
    message,
    deleteItem = () => {},
    timeout = 10000,
    canClose = true,
    progress,
    customStyles
    // custom
  } = props
  const [t] = useTranslation()
  const [closing, setClosing] = useState(false);
  const [isSuccess, setSuccess] = useState<boolean>(false)
  const handleClose = useCallback(() => {
    if (!canClose) {
      return;
    }
    setClosing(true);
    setTimeout(() => {
      deleteItem();
    }, 250);
  }, [canClose, deleteItem]);

  useEffect(() => {
    if (timeout && timeout !== 0) {
      const timer = setTimeout(() => {
        handleClose();
      }, timeout);
      return () => clearTimeout(timer);
    }
  }, [handleClose, timeout]);
  const selectedIcon = (type:string) => {
    switch(type){
      case 'info':
        return Info
      case 'error':
        return Error
      case 'warning':
        return Warning
      case 'image':
        return ImageIcon
      case 'file':
        return Info
      default:
        return Info
    }
  } 
  const selectedSeverityText = (type:string) => {
    switch(type){
      case 'info':
      case 'information':
        return t("INFO")
      case 'error':
        return t("ERROR")
      case 'warning':
        return t("WARNING")
      case 'image':
        return t("UPLOAD_IMAGE")
      case 'file':
        return t("UPLOAD_FILE")
    }
  } 
  useEffect(() => {
    if(progress === 100){
      setSuccess(true)
      const timer = setTimeout(() => {
        deleteItem();
      },5000)
      return () => clearTimeout(timer)
    }
  },[deleteItem, progress])
  return (
    <ThemeProvider theme={(parentTheme:any) =>
      props.isDark === undefined && parentTheme?.palette
        ? parentTheme
        : theme(props.isDark)
    }>
      <AlertCustom
        role={severity === 'error' || severity === 'warning' ? 'alert' : 'status'}
        style={customStyles}
        closing={closing}
      >
        <div style={{display:'flex', justifyContent:'space-between', width:'100%'}}>
          <>
          <IconBackground type={severity}>
            <img src={selectedIcon(severity)} alt="" aria-hidden="true"/>
          </IconBackground>
          <TitleWrapper>
            <Title>
              {selectedSeverityText(severity)}
            </Title>
            {severity === 'image' ?
              <div style={{display:'flex', alignItems:'center',gap:'6px'}}>
                <ThinText>
                    {progress}% 
                </ThinText>
                <Content>
                  {isSuccess ? t("SUCCESSFULY_UPLOAD_IMAGE") : null}
                </Content>
              </div>
            : severity === 'file' ?
              <div style={{display:'flex', alignItems:'center',gap:'6px'}}>
                <ThinText>
                    {progress}% 
                </ThinText>
                <Content>
                  {isSuccess ? t("SUCCESSFULY_UPLOAD_FILE") : null}
                </Content>
              </div>
            :
              <Content>
                {message}
              </Content>
            }
          </TitleWrapper>
          </>
          {canClose &&
            <CloseButton type="button" aria-label={t("CLOSE")} onClick={handleClose}>
              <SVG src={icons.CloseIcon} aria-hidden="true"/>
            </CloseButton>}
        </div>
        {severity === 'image' || severity === 'file' ?
        <ProgressBar aria-label={`${selectedSeverityText(severity)} ${progress}%`} success={isSuccess} value={progress} max="100" />
        : null}
      </AlertCustom>
    </ThemeProvider>
  )
}


export default Alert
